import { therapyPlanningAction } from 'src/redux/actions/constant';

const {
    GET_SINGLE_MDS_ASSESSMENT_REQUEST,
    GET_SINGLE_MDS_ASSESSMENT_SUCCESS,
    GET_SINGLE_MDS_ASSESSMENT_FAILURE,
    GET_SINGLE_MDS_ASSESSMENT_LOADING,
    GET_SINGLE_MDS_ASSESSMENT_RESET,
} = therapyPlanningAction;

const intitialstate: object = {
  response: null,
  loading: false,
  getMdsAssessment: false,
};

export const getSingleMdsAssessmentReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_SINGLE_MDS_ASSESSMENT_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        loading: false,
        getMdsAssessment: true,
      };
    }

    case GET_SINGLE_MDS_ASSESSMENT_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        getMdsAssessment: false,
      };
    case GET_SINGLE_MDS_ASSESSMENT_LOADING:
      return {
        ...state,
        loading: true,
      };

    case GET_SINGLE_MDS_ASSESSMENT_RESET:
      return intitialstate;

    default:
      return state;
  }
};
